import styled from 'styled-components';
import { BlueColors, NeutralColors } from 'theme';

const ActionIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  background-color: ${BlueColors[20]};
  border-radius: 14.4px;
  flex-shrink: 0;

  svg {
    font-size: 20px;
    color: ${BlueColors[60]};
  }
`;

const ActionArrow = styled.div`
  color: ${NeutralColors[60]};
  font-size: 12px;
`;

export { ActionArrow, ActionIcon };
